// Reversible, refcounted document effects for modal layers: scroll lock and
// making everything outside the top layer inert. Two dialogs open → the
// effects stay until both have closed.
let scrollLocks = 0

/** Lock page scrolling (sets `data-scroll-lock` on <html>; base.scss styles it). */
export function lockScroll(): () => void {
  scrollLocks += 1
  document.documentElement.dataset.scrollLock = 'true'
  let released = false
  return () => {
    if (released) return
    released = true
    scrollLocks -= 1
    if (scrollLocks === 0) delete document.documentElement.dataset.scrollLock
  }
}

const inertCounts = new WeakMap<Element, number>()

/**
 * Make every <body> child except `keep` inert. Live regions marked
 * `data-layer-keep` (the notifier) stay interactive and announced.
 */
export function inertOthers(keep: Element): () => void {
  const changed: Element[] = []
  for (const child of Array.from(document.body.children)) {
    if (child === keep || child.contains(keep) || child.hasAttribute('data-layer-keep')) continue
    if (child.tagName === 'SCRIPT') continue
    const count = inertCounts.get(child) ?? 0
    if (count === 0) child.setAttribute('inert', '')
    inertCounts.set(child, count + 1)
    changed.push(child)
  }
  return () => {
    for (const child of changed) {
      const count = (inertCounts.get(child) ?? 1) - 1
      inertCounts.set(child, count)
      if (count === 0) child.removeAttribute('inert')
    }
  }
}
